import styled from "styled-components";
import { Spinner } from "styles/components";
import { Button } from "styles/elements";
import { CenterFlexColumn } from "styles/layout";
import { Theme } from "theme";

export const FormContainer = styled(CenterFlexColumn)`
  padding: ${Theme.bigPanelPadding};
`;

export const FormTable = styled.table`
  th {
    font-weight: 500;
    text-align: right;
    padding-right: 5px;
  }
`;

// todo - extract common styling?
export const Input = styled.input`
  padding: 3px;
  width: 80px;
`;

export const JoinGroupButton = styled(Button)`
  padding: 4px;
  margin-top: 25px;
  font-size: 12pt;
  width: 150px;
`;

export const InProgressSpinner = styled(Spinner)`
  border-width: ${Theme.spinnerSmallBorderWidth};
  width: 15px;
  height: 15px;
  margin: auto;
`;
